import { render, staticRenderFns } from "./AddProduct_ToStock.vue?vue&type=template&id=d564bb5e&scoped=true&"
import script from "./AddProduct_ToStock.vue?vue&type=script&lang=js&"
export * from "./AddProduct_ToStock.vue?vue&type=script&lang=js&"
import style0 from "./AddProduct_ToStock.vue?vue&type=style&index=0&id=d564bb5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d564bb5e",
  null
  
)

export default component.exports